export class DeviceLambdaSetting {
    id: string = ""
    serial: string = ""
    lambdaUrl: string = ""
    isTriggeringLambdaWhenDataUploaded: boolean = false
    isTriggeringLambdaWhenSessionEnded: boolean = false

    constructor(init?:Partial<DeviceLambdaSetting>) {
        if (!init) {
            return
        }

        Object.assign(this, init)
    }
}
